





































































































































































































































import HintsContainer from '@/components/HintsContainer.vue';
import MarketSelect from '@/components/MarketSelect.vue';
import MultiSelect from '@/components/MultiSelect.vue';
import SideToolbar from '@/components/SideToolbar.vue';
import {Generators, TableHeaders} from '@/interfaces/components-data';
import DatePicker from 'vue2-datepicker';
import Files from '@/components/Files.vue';
import '@/extensions';

import {
    ConfigMap,
    IndividualConfig,
    PromoIndividualConfig,
    SelectBox,
    StrategyOfPriceOpt,
    TaskInfoCalc,
    Sales,
    Promotions
} from '@/interfaces/global-data';
import {
    CompetitorsPricesView,
    InternalCodeAndProductRange,
    ProductSegmentIdAndName,
    PromoFilterProducts,
    PromoFilterType,
    Segment,
    Sku,
    TaskAndFile,
    TaskData,
} from '@/interfaces/server-data';
import {EventBus} from '@/mixins/event-bus';
import Http from '@/mixins/http';
import LocalData, {ErrorsMap} from '@/mixins/local-data';
import moment from 'moment';
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import Vue from 'vue';
import vSelect from '@/components/UI/vSelect.vue';
import CSelect from '@/components/UI/CoefficientSelect.vue';
import Toast from '@/mixins/toast';
import CollapseCard from "@/components/UI/CollapseCard.vue"
import Card from '@/components/UI/Card.vue';
import SwitchWithLabel from '@/components/UI/SwitchWithLabel.vue';
import ItemsListTable from "@/pages/ModuleItems/ModuleTabs/ItemsListTab/ItemsListTable.vue";
import ItemsListGanttDiagram from "@/pages/ModuleItems/ModuleTabs/ItemsListTab/ItemsListGanttDiagram.vue";
import CreateItemModal from "@/pages/ModuleItems/ModuleTabs/ItemsListTab/CreateItemModal.vue";
import ItemFilters from "@/pages/ModuleItems/ModuleTabs/ItemsListTab/ItemFilters.vue";
import {
    IModuleItem,
    IModuleItemFilters,
    IModuleItemResponseDto,
    IModuleItemSaveDto,
} from "@/pages/ModuleItems/data";
import ModuleApi from "@/pages/ModuleItems/ModuleApi";
import Parameters from "@/pages/ModuleItems/ModuleTabs/ParametersTab/Parameters.vue";
import CompetitorsPricesList from "@/pages/ModuleItems/ModuleTabs/CompetitorsPricesTab/CompetitorsPricesList.vue";
import ProductsList from "@/pages/ModuleItems/ModuleTabs/ProductsListTab/ProductsList.vue";
import ReportsLog from "@/pages/ModuleItems/ModuleTabs/ReportsLogTab/ReportsLog.vue";
import RoundingPrices from "@/pages/ModuleItems/ModuleTabs/RoundingPricesTab/RoundingPrices.vue";
import ReportsSchedule from "@/pages/ModuleItems/ModuleTabs/ReportsScheduleTab/ReportsSchedule.vue";
import ItemsMonitor from "@/pages/ModuleItems/ModuleTabs/ItemsMonitorTab/ItemsMonitor.vue";
import CategoryParams from "@/pages/ModuleItems/ModuleTabs/CategoryParamsTab/CategoryParams.vue";
import Recommendations from "@/pages/ModuleItems/ModuleTabs/RecommendationsTab/Recommendations.vue";
import { TModuleType } from "@/pages/ModuleItems/data";

@Component({
    computed: {
        moment() {
          return moment;
        },
        PromoFilterType() {
            return PromoFilterType;
        },
        PromoFilterProducts() {
            return PromoFilterProducts;
        }
    },
    components: {
        ReportsLog,
        RoundingPrices,
        SideToolbar,
        MultiSelect,
        MarketSelect,
        vSelect,
        HintsContainer,
        DatePicker,
        CollapseCard,
        Card,
        CSelect,
        ItemFilters,
        CreateItemModal,
        ItemsListTable,
        ItemsListGanttDiagram,
        Parameters,
        ProductsList,
        Files,
        CompetitorsPricesList,
        ItemsMonitor,
        SwitchWithLabel,
        ReportsSchedule,
        CategoryParams,
        Recommendations,
    },
})
export default class ModuleTabsManagement extends Mixins(Toast, Http, LocalData) {
    @Prop({ default: null }) readonly activeTabKeyProp?: string | null;
    @Prop() readonly moduleType!: TModuleType;

    tModule(path: string): string {
        const namespace = this.moduleType === 'promo' ? 'promo' : 'sales';
        return this.$t(`${namespace}.${path}`) as string;
    }

    @Watch('filters', {deep: true})
    onFiltersChanged() {
        if (this.isAfterReset) {
            (this.$refs.itemsTable as ItemsListTable).fetchData(true);

            this.isAfterReset = false;
        } else {
            (this.$refs.itemsTable as ItemsListTable).fetchData();
        }
    }

    get routerPath(): string {
        if (this.moduleType === 'promo') {
            return '/promotions';
        } else {
            return '/sales';
        }
    }

    @Watch('activeTabKey')
    onActiveTabKeyChanged(key: string, prevKey: string) {
        if (key === 'monitorTab' && this.$refs.itemsMonitorRef && (this.$refs.itemsMonitorRef as Vue).$refs && (this.$refs.itemsMonitorRef as Vue).$refs.itemsGanttDiagram && this.needFetchItemsInDiagram) {
            ((this.$refs.itemsMonitorRef as ItemsMonitor).$refs.itemsGanttDiagram as ItemsListGanttDiagram).fetchItems();

            this.needFetchItemsInDiagram = false;
        }

        if (prevKey === 'reportsLogTab') {
            if (this.$route.params.hasOwnProperty('reportId')) {
                this.$router.push(this.routerPath);
            }
        } else if (key === 'reportsLogTab' && !this.$route.params.hasOwnProperty('reportId') && this.$refs.reportsLogRef) {
            const reportToView = (this.$refs.reportsLogRef as ReportsLog).taskToView;

            if (reportToView && reportToView.id) {
                this.$router.push(`${this.routerPath}/` + reportToView.id);
            }
        }
    }

    get moduleData(): Sales | Promotions {
        if (this.moduleType === 'promo') {
            return this.$promotions;
        } else {
            return this.$sales;
        }
    }

    set moduleData(data: Sales | Promotions) {
        if (this.moduleType === 'promo') {
            this.$promotions = data as Promotions;
        } else {
            this.$sales = data as Sales;
        }
    }

    get disableCreateButton(): boolean {
        return ['formatSelected'].some(key => !this.filters[key as keyof IModuleItemFilters] || this.filters[key as keyof IModuleItemFilters] === -1);
    }

    get categoryParamsInitFilters() {
        return {
            groupId: this.currentItem.groups[0] ? this.currentItem.groups[0].id : null,
            formatId: this.currentItem.format ? this.currentItem.format.id : null,
        }
    }

    created() {
        if (this.activeTabKeyProp) {
            this.activeTabKey = this.activeTabKeyProp;

            localStorage.setItem(this.moduleType === 'promo' ? 'promotionsActiveTabKey' : 'salesActiveTabKey', this.activeTabKeyProp);
        } else {
            const moduleActiveTabKey = localStorage.getItem(this.moduleType === 'promo' ? 'promotionsActiveTabKey' : 'salesActiveTabKey');

            if (moduleActiveTabKey) {
                this.activeTabKey = moduleActiveTabKey;
            }
        }

        const moduleLSData = localStorage.getItem(this.moduleType === 'promo' ? 'promotions' : 'sales');

        if (!!moduleLSData) {
            this.filters = {
                market: this.moduleData.selectMarket,
                groupIds: this.moduleData.groupIds,
                categoryIds: this.moduleData.categoryIds,
                subcategory: this.moduleData.subcategories.length ? this.moduleData.subcategories : -1,
                formatSelected: this.moduleData.formatSelected || -1,
                regionIds: this.moduleData.regionIds,
                clusterIds: this.moduleData.clusterIds,
            };
        }
    }

    private filters: IModuleItemFilters = {
        market: null,
        groupIds: [],
        categoryIds: [],
        subcategory: -1,
        formatSelected: -1,
        regionIds: [],
        clusterIds: [],
    };

    private resetFilters(needIgnoreFilters: boolean = false) {
        this.filters.groupIds = [];
        this.filters.categoryIds = [];
        this.filters.subcategory = -1;
        this.filters.formatSelected = -1;
        this.filters.regionIds = [];
        this.filters.clusterIds = [];

        if (needIgnoreFilters) {
            this.isAfterReset = true;
        }
    }

    private updateFilters(data: any) {
        Object.keys(data).forEach(key => {
            this.filters[key as keyof IModuleItemFilters] = data[key];
        });
    }

    private activeTabKey: string = 'monitorTab';
    private needFetchItemsInDiagram = false;
    private needReturnToItemsIn: string = 'itemsListTab';
    private isAfterReset: boolean = false;

    private createModalErrObj: any = null;
    private updatePageErrObj: any = null;

    private api: ModuleApi = new ModuleApi({parent: this});

    private productsListPageKey: number = 1;

    private currentItem: IModuleItemResponseDto = {
        id: null,
        startDate: null,
        endDate: null,
        name: null,
        type: null,
        status: null,
        stagesNumber: null,
        minSaleDiscount: null,
        maxSaleDiscount: null,
        minPromotionDiscount: null,
        maxPromotionDiscount: null,
        minMargin: null,
        tradingId: null,
        groups: [{
            id: 0,
            name: ''
        }],
        categories: [{
            id: 0,
            name: ''
        }],
        subcategory: {
            id: 0,
            name: ''
        },
        format: {
            id: 0,
            name: ''
        },
        regions: [{
            id: 0,
            name: ''
        }],
        clusters: [{
            id: 0,
            name: ''
        }],
        skuCount: null,
        remains: null,
        taskId: null,
        revaluationFileName: null,
    };

    private formErrors: ErrorsMap = {};
    private showFormError: boolean = false;

    private saveModuleItem(params: IModuleItemSaveDto): Promise<any> {
        return new Promise<IModuleItem>((resolve, reject) => {
            this.api.saveItem(this.moduleType, params)
                .then((res) => {
                    resolve(res as any);
                })
                .catch((err) => {
                    reject(err);
                    this.showError(this.$t(this.moduleType === 'promo' ? 'shared.messages.savePromoError' : 'shared.messages.saveSaleError') as string);
                })
        })
    }

    private handeSaveButtonClicked(itemObj: IModuleItemSaveDto) {
        this.hideFormErrors('saveModuleItem');

        let itemToSave: IModuleItem | IModuleItemSaveDto = Object.assign({}, itemObj);

        if (this.moduleData.selectMarket.id != null) {
             Object.assign(itemToSave, {
                id: null,
                tradingId: this.moduleData.selectMarket.id,
                groupIds: this.filters.groupIds.realValuesOrEmpty(),
                categoryIds: this.filters.categoryIds.realValuesOrEmpty(),
                subcategoryId: this.filters.subcategory === -1 ? null : this.filters.subcategory,
                formatId: this.filters.formatSelected.negativeToNull(),
                regionIds: this.filters.regionIds.realValuesOrEmpty(),
                clusterIds: this.filters.clusterIds.realValuesOrEmpty(),
            });
        }
            this.saveModuleItem(itemToSave)
                .then(() => {
                    this.createModalErrObj = null;
                    this.showInfo(this.$t(this.moduleType === 'promo' ? 'shared.messages.savePromoSuccess' : 'shared.messages.saveSaleSuccess') as string);

                    (this.$refs.itemsTable as ItemsListTable).fetchData();
                    this.needFetchItemsInDiagram = true;

                    (this.$refs.createItemModal as any).handleCancelClick();
                    this.returnToItemsList();

                    // temporary - in this place I need response from server in then() - it must be created ITEM object, but now - nothing
                    this.api.fetchItems(this.moduleType, {
                        tradingId: this.moduleData.selectMarket.id,
                        page: 0,
                        size: 1000,
                    })
                        .then((resp) => {
                            if (resp.status === 200) {
                                const savedItem = resp.data.content[0]; // just added

                                if (savedItem) {
                                    this.currentItem = Object.assign({}, savedItem);
                                }
                            }
                        });
                    // /temporary
                })
                .catch((err) => {
                    this.createModalErrObj = err;
                });
    }

    private handleItemBasicParamsUpdated(result: any) {
        if (result.success) {
            this.currentItem = Object.assign({}, result.data);
            this.productsListPageKey++;

            this.updatePageErrObj = null;
            this.showInfo(this.$t(this.moduleType === 'promo' ? 'shared.messages.savePromoSuccess' : 'shared.messages.saveSaleSuccess') as string);

            (this.$refs.itemsTable as ItemsListTable).fetchData();
            this.needFetchItemsInDiagram = true;

            (this.$refs.createItemModal as any).handleCancelClick();
        } else {
            this.updatePageErrObj = result.err;
        }
    }

    private hideFormErrors(form: string) {
        this.formErrors[form] = {};
        this.showFormError = false;
    }

    file: File | null = null;
    productLineOptions: Array<SelectBox<string>> = [];
    productLineOptionsForFilter: Array<SelectBox<string>> = [];
    selectProductLine: string = {value: 'all', label: this.$t('shared.selectBox.all') as string}.value;

    productRangesArray: InternalCodeAndProductRange[] = [];

    defaultFilterValue = {value: -1, label: this.$t('shared.selectBox.all') as string};
    secondDefaultFilterValue = {value: -2, label: this.$t('shared.selectBox.empty') as string};

    selectProducts: PromoFilterProducts = {value: PromoFilterProducts.ALL, label: this.$t('shared.productFilter.all') as string}.value;
    selectProductsTypeForRecommends: PromoFilterProducts = PromoFilterProducts.ALL;
    selectProductsForPiRecommends: SelectBox<PromoFilterProducts> = {value: PromoFilterProducts.ALL, label: this.$t('shared.productFilter.all') as string};
    selectProductsForCdRecommends: SelectBox<PromoFilterProducts> = {value: PromoFilterProducts.ALL, label: this.$t('shared.productFilter.all') as string};
    selectProductsForIgRecommends: SelectBox<PromoFilterProducts> = {value: PromoFilterProducts.ALL, label: this.$t('shared.productFilter.all') as string};
    productFilterOptions: Array<SelectBox<PromoFilterProducts>> = [
        {value: PromoFilterProducts.ALL, label: this.$t('shared.productFilter.all') as string},
        {value: PromoFilterProducts.PROMO, label: this.$t('shared.productFilter.promo') as string},
        {value: PromoFilterProducts.REGULAR, label: this.$t('shared.productFilter.regular') as string},
    ];

    selectKVI: number = this.defaultFilterValue.value;
    selectKVIForNewProducts: number = this.defaultFilterValue.value;
    selectKVIRecommends: number = this.defaultFilterValue.value;
    kviValueForRecommends: number = -1;
    selectKVIForPiRecommends: SelectBox<number> = this.defaultFilterValue;
    selectKVIForCdRecommends: SelectBox<number> = this.defaultFilterValue;
    selectKVIForIgRecommends: SelectBox<number> = this.defaultFilterValue;
    kviOptions: Array<SelectBox<number>> = [
        {value: -1, label: this.$t('shared.kviFilter.all') as string},
        {value: 1, label: this.$t('shared.kviFilter.kvi') as string},
        {value: 0, label: this.$t('shared.kviFilter.notKvi') as string},
    ];

    kviRecommendsOptions: Array<SelectBox<number>> = [
        {value: -1, label: this.$t('shared.kviRecommendsFilter.all') as string},
        {value: 0, label: this.$t('shared.kviRecommendsFilter.gk') as string},
        {value: 1, label: this.$t('shared.kviRecommendsFilter.cvk') as string},
    ];

    selectCTM: string = {value: 'all', label: this.$t('shared.selectBox.all') as string}.value;
    selectCTMForNewProducts: string = {value: 'all', label: this.$t('shared.selectBox.all') as string}.value;
    ctmValueForRecommends: string | null = null;
    selectCTMForPiRecommends: SelectBox<string> = {value: 'all', label: this.$t('shared.selectBox.all') as string};
    selectCTMForCdRecommends: SelectBox<string> = {value: 'all', label: this.$t('shared.selectBox.all') as string};
    selectCTMForIgRecommends: SelectBox<string> = {value: 'all', label: this.$t('shared.selectBox.all') as string};
    ctmOptions: Array<SelectBox<string>> = [
        {value: 'all', label: this.$t('shared.ctmFilter.all') as string},
        {value: '1', label: this.$t('shared.ctmFilter.ctm') as string},
        {value: '0', label: this.$t('shared.ctmFilter.notCtm') as string},
    ];

    selectSegmentPrice: Segment[] = [];
    selectSegmentPriceForNewProducts: Segment[] = [];
    segmentPriceValueForRecommends: Segment[] = [];
    selectPiRecommendsSegmentPrice: Segment[] = [];
    selectCdRecommendsSegmentPrice: Segment[] = [];
    selectIgRecommendsSegmentPrice: Segment[] = [];
    segmentPriceOptions: Array<SelectBox<Segment>> = [];
    segmentPriceOptionsForNewProducts: Array<SelectBox<Segment>> = [];
    segmentPriceForRecommendsOptions: Array<SelectBox<Segment>> = [];
    selectProductSegmentIdAndName: ProductSegmentIdAndName[] = [];
    selectNewProductSegmentIdAndName: ProductSegmentIdAndName[] = [];
    newProductSegmentIdAndNameOptions: Array<SelectBox<ProductSegmentIdAndName>> = [];
    productSegmentIdAndNameOptions: Array<SelectBox<ProductSegmentIdAndName>> = [];
    tableKey = 1;
    competitorTableKey = 1;

    selectKeyCharacteristicOne: string[] = [];
    selectKeyCharacteristicTwo: string[] = [];
    selectRecipeAttributes: string[] = [];
    selectTreatmentAttributes: number[] = [];

    selectKeyCharacteristicOneForNewProduct: string[] = [];
    selectKeyCharacteristicTwoForNewProduct: string[] = [];
    selectRecipeAttributesForNewProduct: string[] = [];
    selectTreatmentAttributesForNewProduct: number[] = [];

    keyCharacteristicOneOptions: Array<SelectBox<string>> = [];
    keyCharacteristicTwoOptions: Array<SelectBox<string>> = [];
    recipeAttributesOptions: Array<SelectBox<string>> = [];
    treatmentAttributesOptions: Array<SelectBox<number>> = [];

    keyCharacteristicOneForNewProductOptions: Array<SelectBox<string>> = [];
    keyCharacteristicTwoForNewProductOptions: Array<SelectBox<string>> = [];
    recipeAttributesForNewProductOptions: Array<SelectBox<string>> = [];
    treatmentAttributesForNewProductOptions: Array<SelectBox<number>> = [];

    taskInfo: TaskInfoCalc = {
        storeFormatOptions: [{value: null, label: this.$t('shared.selectBox.all') as string}],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [{value: null, label: this.$t('shared.selectBox.selectCategory') as string}],
        clusterOptions: [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}],
        groupsOfProduct: [{value: null, label: this.$t('shared.selectBox.all') as string}],
        subcategories: [],
        subcategoriesDefault: [{value: null, label: this.$t('shared.selectBox.all') as string}],
        psegemnts: [],
    };
    taskInfoRecommends: TaskInfoCalc = {
        storeFormatOptions: [],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [],
        clusterOptions: [],
        groupsOfProduct: [],
        subcategories: [],
        subcategoriesDefault: [],
        psegemnts: [],
    };
    taskInfoForRoundingRules: TaskInfoCalc = {
        storeFormatOptions: [{value: null, label: this.$t('shared.selectBox.all') as string}],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [{value: null, label: this.$t('shared.selectBox.selectCategory') as string}],
        clusterOptions: [{value: null, label: this.$t('shared.selectBox.selectCluster') as string}],
        groupsOfProduct: [{value: null, label: this.$t('shared.selectBox.all') as string}],
        subcategories: [],
        subcategoriesDefault: [{value: null, label: this.$t('shared.selectBox.all') as string}],
        psegemnts: [],
    };
    promoSkuOfferRunning: boolean = false;
    searchable: boolean = true;
    usePromoRecommendsFilter: boolean = false;
    skuFilter: string = '';
    newProductsFilter: string = '';
    skuRecommendsFilter: string = '';
    skuList: Sku[] = [];
    skuListWithAllProducts: Sku[] = [];
    newProductsList: Sku[] = [];
    newProductsListWithAllProducts: Sku[] = [];
    fileResult: string = '';
    taskId: number = 0;
    trafficGenerators: Generators[] = [];
    incomeGenerators: Generators[] = [];
    cartDrivers: Generators[] = [];
    defaultIntSelectBox: Array<SelectBox<number>> = [{value: 0, label: this.$t('shared.selectBox.all') as string}];
    promoFilter: Array<SelectBox<PromoFilterType>> = [
        {value: PromoFilterType.all, label: this.$t('shared.promoFilter.all') as string},
        {value: PromoFilterType.ig, label: this.$t('shared.promoFilter.ig') as string},
        {value: PromoFilterType.cd, label: this.$t('shared.promoFilter.cd') as string},
        {value: PromoFilterType.pi, label: this.$t('shared.promoFilter.pi') as string},
    ];
    selectedPromoFilter: PromoFilterType = {value: PromoFilterType.all, label: this.$t('shared.promoFilter.all') as string}.value;
    recommendsType: PromoFilterType = PromoFilterType.pi;
    skuListLimit: number = 20;
    newProductsListLimit: number = 20;

    taskData: TaskAndFile | null = null;

    competitors: CompetitorsPricesView[] = [];

    newProductsPagination: any = {
        pageSize: 20,
        current: 1,
    };

    rulesTableFields: TableHeaders[] = [
        {key: 'fileDownload', label: this.$t('shared.rulesTable.actions') as string},
        {key: 'errors', label: this.$t('shared.rulesTable.errors') as string},
        {key: 'uploadDate', label: this.$t('shared.rulesTable.uploadDate') as string},
        {key: 'user', label: this.$t('shared.rulesTable.user') as string},
        {key: 'storeFormat', label: this.$t('shared.rulesTable.storeFormat') as string},
        {key: 'storeRegions', label: this.$t('shared.rulesTable.storeRegions') as string},
        {key: 'storeCluster', label: this.$t('shared.rulesTable.storeCluster') as string},
        {key: 'groupsOfProduct', label: this.$t('shared.rulesTable.groupsOfProduct') as string},
        {key: 'categories', label: this.$t('shared.rulesTable.categories') as string},
        {key: 'subcategories', label: this.$t('shared.rulesTable.subcategories') as string},
    ];

    newRulesTableFields: any[] = [
        {
            dataIndex: 'fileDownload',
            title: this.$t('shared.rulesTable.actions') as string,
            scopedSlots: { customRender: 'fileDownload' },
        },
        {
            dataIndex: 'errors',
            title: this.$t('shared.rulesTable.errors') as string,
            scopedSlots: { customRender: 'errors' }},
        {
            dataIndex: 'uploadDate',
            title: this.$t('shared.rulesTable.uploadDate') as string,
            customRender: (value: number) => moment(moment.utc(value)).local().format('DD/MM/YYYY HH:mm:ss'),
            scopedSlots: { filterDropdown: 'uploadDateFilter', filterIcon: "uploadDateFilterIcon" },
            ellipsis: true,
        },
        {
            dataIndex: 'user',
            title: this.$t('shared.rulesTable.user') as string,
            scopedSlots: { filterDropdown: 'userFilter', filterIcon: "userFilterIcon" },
            ellipsis: true,
        },
        {
            dataIndex: 'storeFormat',
            title: this.$t('shared.rulesTable.storeFormat') as string,
            scopedSlots: { filterDropdown: 'storeFormatFilter', filterIcon: "storeFormatFilterIcon" },
            ellipsis: true,
        },
        {
            dataIndex: 'storeRegions',
            title: this.$t('shared.rulesTable.storeRegions') as string,
            scopedSlots: { filterDropdown: 'storeRegionsFilter', filterIcon: "storeRegionsFilterIcon" },
            ellipsis: true,
        },
        {
            dataIndex: 'storeCluster',
            title: this.$t('shared.rulesTable.storeCluster') as string,
            scopedSlots: {filterDropdown: 'storeClusterFilter', filterIcon: "storeClusterFilterIcon"},
            ellipsis: true,
        },
        {
            dataIndex: 'groupsOfProduct',
            title: this.$t('shared.rulesTable.groupsOfProduct') as string,
            scopedSlots: { filterDropdown: 'groupsOfProductFilter', filterIcon: "groupsOfProductFilterIcon" },
            ellipsis: true,
        },
        {
            dataIndex: 'categories',
            title: this.$t('shared.rulesTable.categories') as string,
            scopedSlots: { filterDropdown: 'categoriesFilter', filterIcon: "categoriesFilterIcon" },
            ellipsis: true,
        },
        {
            dataIndex: 'subcategories',
            title: this.$t('shared.rulesTable.subcategories') as string,
            scopedSlots: { filterDropdown: 'subcategoriesFilter', filterIcon: "subcategoriesFilterIcon" },
            ellipsis: true,
        },
    ];

    tableData: any = [];
    pagination: any = {
        pageSize: 20,
    };

    loadingConfigs = false;
    marginalErrorText = ''
    marginalSkuErrorText = ''
    incorrectPeriodErrorText = '';
    globalNewProductIndividualMarginalErrorText = '';
    globalIndividualMarginalErrorText = '';
    globalNewProductIndividualMarginalBlockButton = false;
    globalLiftBlockButton = false;
    globalNewProductLiftBlockButton = false;
    globalIndividualMarginalBlockButton = false;
    globalIndividualPeriodPriceIncreaseLimitBlockButton = false;
    globalIndividualPriceIncreaseLimitBlockButton = false;

    downloadLastExcelHeaderByFilters: boolean = false;
    downloadLastExcelDetailByFilters = false;
    skuListPerPage = 20;
    newProductListPerPage: number = 20;
    skuListCurrentPage: number = 1;
    skuRecommendsListCurrentPage: number = 1;
    newProductsListCurrentPage: number = 1;
    skuListTotalRows: number = 0;
    newProductsListTotalRows: number = 0;
// tslint:disable-next-line: ban-types
    onDropdownClosed: Function | null = null;
    needLoadSkuList: boolean = false;
    showBookmarks: boolean = true;
    showPromoRecommendsBookmarks: boolean = true;
    showMainFilters: boolean = true;
    showMainRecommendsFilters: boolean = true;
    needLoadNewProductList: boolean = false;
    firstDate: number = 0;
    lastDate: number = 0;
    calcModalShow: boolean = false;
    recalculatingRegularPricesModalShow: boolean = false;
    isActualProfitabilityCalculated: boolean = false;
    isRegularPricesProfitabilityCalculated: boolean = false;
    isDataRangeCalculated: boolean = false;
    isPriceCorridorCalculated: boolean = false;
    isFetchSkuListDownload: boolean = false;
    isFetchNewProductsListDownload: boolean = false;
    isLoadCompetitorPrices: boolean = false;
    kviSaveProcess: boolean = false;
    calcSkuActualProfitButtonDisabled: boolean = false;
    newProductsLastPage: number = 0;
    calcSkuLastPricesButtonDisabled: boolean = false;
    useFindKviRecommendsParam: boolean = false;
    isFiltersChangedForRecommends = 1;
    loadProgress: boolean = false;
    progressCounter: number = 0;
    rulesCurrentPage = 1;
    rulesTotalRows = 0;
    rulesPerPage = 20;
    rulesTableKey = 1;
    rulesDateRange: string[] = [];
    showDeleteFileModal: boolean = false;
    fileIdForDelete: number = -1;
    serverConfigTimeout: number | null = null;

    selectUserFio: string = 'All';
    usersFioList: Array<SelectBox<string>> = [];

    selectTradingFilter: SelectBox<number> = this.defaultFilterValue;
    tradingsFilterOptions: Array<SelectBox<number>> = [];

    selectCategoryFilter: number = this.defaultFilterValue.value;
    categoryFilterOptions: Array<SelectBox<number>> = [];

    selectGroupFilter: number = this.defaultFilterValue.value;
    groupFilterOptions: Array<SelectBox<number>> = [];

    selectSubcategoryFilter: number = this.defaultFilterValue.value;
    subcategoryFilterOptions: Array<SelectBox<number>> = [];

    selectFormatFilter: number = this.defaultFilterValue.value;
    formatFilterOptions: Array<SelectBox<number>> = [];

    selectRegionFilter: number = this.defaultFilterValue.value;
    regionFilterOptions: Array<SelectBox<number>> = [];

    selectClusterFilter: number = this.defaultFilterValue.value;
    clusterFilterOptions: Array<SelectBox<number>> = [];

    isFixPricePromo: boolean = false;

    private viz: any | null = null;

    mounted() {
        // temporary - to remove after deploy to all customers
        if (this.moduleType === 'promo') {
            const isPromotionsToSkipClearingLocalstorage = localStorage.getItem('promotionsToSkipClearingLocalstorage');

            if (!isPromotionsToSkipClearingLocalstorage || (isPromotionsToSkipClearingLocalstorage !== 'version_24-11-2025')) {
                localStorage.removeItem('promotions');
                localStorage.setItem('promotionsToSkipClearingLocalstorage', 'version_24-11-2025');

                this.$router.go(this.$router.currentRoute as any);
            }
        } else {
            const isSalesToSkipClearingLocalstorage = localStorage.getItem('salesToSkipClearingLocalstorage');

            if (!isSalesToSkipClearingLocalstorage || (isSalesToSkipClearingLocalstorage !== 'version_24-11-2025')) {
                localStorage.removeItem('sales');
                localStorage.setItem('salesToSkipClearingLocalstorage', 'version_24-11-2025');

                this.$router.go(this.$router.currentRoute as any);
            }
        }
        // /temporary

        this.$promo.selectCoefficent = {value: {k1: 1, k2: 0, enum: StrategyOfPriceOpt.maxGrosMargin}, label: this.$t('shared.strategy.maxGrossMargin') as string};

        this.$forceUpdate();
    }

    onCalcEventReceived(data: TaskData) {
        if (this.showCalcProgress(data.status)) {
        }
    }

    beforeDestroy() {
        this.$calc.hintsLoaded = false
        this.$calc.currentModuleHints = []
        EventBus.$off('calc', this.onCalcEventReceived);
        EventBus.$off('packagePromoRecommends', this.onCalcEventReceived);
    }

    destroyed() {
        if (this.viz != null) {
            this.viz.dispose();
        }
    }

    showCalcProgress(status: string): boolean {
        return (status === 'WriteToFileComplete'
                || status === 'EmptyData'
                || status === 'ExecutionException'
                || status === 'PromoNotRecommended'
                || status.includes('Error'));
    }

    setCalcIndividConfig(config: ConfigMap<IndividualConfig>, sku: string, property: keyof IndividualConfig, value: number | SelectBox<any> | string) {
        if (!(sku in config)) {
            config[sku] = {};
        }
        config[sku][property] = value;
    }

    setPromoIndividConfig(config: ConfigMap<PromoIndividualConfig>, sku: string, property: keyof PromoIndividualConfig, value: number | SelectBox<any>) {
        if (!(sku in config)) {
            config[sku] = {};
        }
        if (typeof value === 'number' && Number.isNaN(value)) {
            config[sku][property] = null;
        } else {
            config[sku][property] = value;
        }
    }

    private toParametersTab(item: IModuleItemResponseDto, isFromMonitorTab?: boolean): void {
        this.currentItem = Object.assign({}, item);

        if (isFromMonitorTab) {
            this.needReturnToItemsIn = 'monitorTab';
        } else  {
            this.needReturnToItemsIn = 'itemsListTab';
        }

        this.activeTabKey = 'parametersTab';

        setTimeout(() => { (this.$refs.contentWrapper as HTMLElement).scrollIntoView({ behavior: "smooth" }); }, 500);
    }

    private returnToItemsList(): void {
        this.activeTabKey = this.needReturnToItemsIn;

        if (this.needReturnToItemsIn === 'itemsListTab') {
            setTimeout(() => { (this.$refs.itemsTable as Vue).$el.scrollIntoView({ behavior: "smooth" }); }, 500);
        } else {
            if (this.$refs.itemsMonitorRef && (this.$refs.itemsMonitorRef as Vue).$refs && (this.$refs.itemsMonitorRef as Vue).$refs.itemsGanttDiagram) {
                (this.$refs.itemsMonitorRef as ItemsMonitor).activeTabKey = 'ganttDiagram';

                setTimeout(() => { ((this.$refs.itemsMonitorRef as Vue).$refs.itemsGanttDiagram as ItemsListGanttDiagram).$el.scrollIntoView({ behavior: "smooth" }); }, 700);
            }
        }
    }

    private handleItemDeleted(itemId: number): void {
        (this.$refs.itemsTable as ItemsListTable).fetchData();
        this.needFetchItemsInDiagram = true;

        if (this.currentItem.id == itemId) {
            this.currentItem = {
                id: null,
                startDate: null,
                endDate: null,
                name: null,
                type: null,
                status: null,
                stagesNumber: null,
                minSaleDiscount: null,
                maxSaleDiscount: null,
                minPromotionDiscount: null,
                maxPromotionDiscount: null,
                minMargin: null,
                tradingId: null,
                groups: [{
                    id: 0,
                    name: ''
                }],
                categories: [{
                    id: 0,
                    name: ''
                }],
                subcategory: {
                    id: 0,
                    name: ''
                },
                format: {
                    id: 0,
                    name: ''
                },
                regions: [{
                    id: 0,
                    name: ''
                }],
                clusters: [{
                    id: 0,
                    name: ''
                }],
                skuCount: null,
                taskId: null,
                remains: null,
                revaluationFileName: null,
            };
        }
    }

    handleSelectedTabsChange() {
        if (!['parametersTab', 'priceListSubTab'].includes(this.activeTabKey)) {
            localStorage.setItem(this.moduleType === 'promo' ? 'promotionsActiveTabKey' : 'salesActiveTabKey', this.activeTabKey);
        } else {
            localStorage.setItem(this.moduleType === 'promo' ? 'promotionsActiveTabKey' : 'salesActiveTabKey', 'monitorTab');
        }
    }
}
